import { render } from "./BrandsCmsPage.vue?vue&type=template&id=6d88808e"
import script from "./BrandsCmsPage.vue?vue&type=script&lang=js"
export * from "./BrandsCmsPage.vue?vue&type=script&lang=js"

import "./BrandsCmsPage.vue?vue&type=style&index=0&id=6d88808e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__